import axios from '@/core/axios';

import { RepairCostsImportResponse } from './repair-costs.types';

export class RepairCostsService {
  importRepairCost(file: File): Promise<RepairCostsImportResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return axios
      .post<RepairCostsImportResponse>('/repair/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then(resp => resp?.data);
  }
}

export const repairCostsService = new RepairCostsService();
